import { useState, useEffect } from "react";
import { Grid, Dialog, Box, Divider, Badge } from "@mui/material";
import { loginState, configState } from "../lib/State";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import axios from "axios";
import HomeMemberLevel from "./HomeMemberLevel";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Notification from "./Notification";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";

const typoTheme = createTheme({
  typography: {
    fontFamily: "BebasNeue",
  },
});

const dividerTheme = createTheme({
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          // boxShadow: '0 4px 4px -4px black'
        },
      },
    },
  },
});

function HomeLevel(props) {
  const { login } = props;
  const [open, setOpen] = useState(false);
  const cid = get_cid();
  const [membership, setMembership] = useState('-');
  // const token = localStorage.getItem("token");
  // const [loaded, setLoaded] = useState(false);
  // const [maxWidth, setMaxWidth] = useState('lg');
  // const [fullWidth, setFullWidth] = useState(true);

  const openClick = () => {
    setOpen(true);
  };
  const closeClick = () => {
    setOpen(false);
  };

  const load_data = async () => {
    let postData = {
      token: get_token(),
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(configState.api + "/gympass/home_membership", postData);
    setMembership(result.data.count);
  };

  useEffect(() => {
    if (login.mcd !== "") {
      load_data();
    }
  }, [login.mcd]);

  return (
    <Grid
      container
      display="flex"
      // height="35vh"
      justifyContent="center"
      alignItems="center"
      position="relative"
    >
      
      {/* {cid==='CT14Z01170314.HXZb9' &&
        <img src='/img/okpo_summer_main.jpg' style={{ width: '100%'}}></img>
      }
      {cid!=='CT14Z01170314.HXZb9' &&
        <img src="/img/main_summer72.png" style={{ width: "100%" }}></img>
      } */}
      
      <img src={cid !== "CT14S15143839.Pdfg3" ? "/img/main_230718.png" : "/img/main_test.png"} width='100%' />
      {/* {login.mcd === "" ? null : (
        <Box
          sx={{
            marginTop: '-170px',
            display: 'flex',
            justifyContent: 'flex-end',
            width: '90%',
            color: 'white',
            // fontFamily: 'BebasNeue',
            fontSize: '20px'
          }}>
          <Box>
            Lv.
          </Box>
          {membership <= 60 &&
            <Box>
              Silver
            </Box>
          }
          {membership > 60 &&
            <Box>
              Gold
            </Box>
          }
          
        </Box>
      )} */}
      
      {/* {login.mcd === "" ? null : (
        <Box
          sx={{
            border: "1px solid white",
            borderRadius: "10px",
            boxShadow:
              " 0 0 10px #80d3da inset, 0 0 5px #80d3da inset, 0 0 5px white, 0 0 5px #80d3da, 0 0 10px #80d3da",
            width: "85%",
            fontSize: "16px",
            // position: 'absolute',
            // left: 0,
            // bottom: 0,
            marginTop: "-130px",
            padding: "5px 10px",
            display: "flex",
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            textDecoration: "none",
          }}
          onClick={openClick}
        >
          <Box sx={{ marginLeft: "7px", color: "white", fontWeight: 900 }}>
            당신의 멤버십 레벨은?
          </Box>
          <ThemeProvider theme={typoTheme}>
            <Box
              sx={{
                marginRight: "7px",
                color: "white",
                fontFamily: "BebasNeue",
                fontSize: "25px",
              }}
            >
              {membership <= 60 &&
                <Box
                  sx={{
                    fontSize: "22px",
                    fontWeight: "bold",
                    // color: "#7a7a7a",
                  }}
                >
                  Silver
                </Box>
              }
              {membership > 60 &&
                <Box
                  sx={{
                    fontSize: "22px",
                    fontWeight: "bold",
                    color: "#dbc93f",
                  }}
                >
                  Gold
                </Box>
              }
            </Box>
          </ThemeProvider>
        </Box>
      )} */}
    </Grid>
  );
}

export default HomeLevel;
